import { postAPICall } from '../helpers/httpHelper';
import { db } from '../utils/db';
import axios from 'axios';
import appConfig from '@/config/app';
import store from '@/store';

let iconsCache = new Map();

export const addIconsToLocal = async (icons) => {
  const localIcons = await fetchAllIconsFromLocal();
  const existingKeysSet = new Set(localIcons.map((i) => i.key));
  const newIcons = icons.filter((icon) => !existingKeysSet.has(icon.key));
  return await db.icons.bulkAdd(
    newIcons.map((d) => ({
      ...d,
      createdAt: new Date().toISOString(),
    }))
  );
};

export const addSingleIcon = async (data) => {
  try {
    if (data?.name && data?.content) {
      let icon = await fetchIconFromLocal(data.name);
      if (!icon) {
        return db.icons.add({
          ...data,
          ...{ createdAt: new Date().toISOString() },
        });
      }
    }
  } catch (e) {
    console.log('addSingleIcon', e);
  }
};

export const fetchAllIconsFromLocal = () => {
  return db.icons.toArray();
};

export const fetchIconFromDatabase = async (name) => {
  const result = await postAPICall('GET', `/icons/byName/${name}`);
  addSingleIcon(result.data);
  return result.data;
};

export const fetchIconByKey = async (key) => {
  let icon;
  icon = await fetchIconFromLocal(key);
  return icon;
};

export const fetchIconFromLocal = async (key) => {
  try {
    if (!key) {
      key = 'dashboard';
    }
    if (iconsCache.has(key)) {
      return iconsCache.get(key);
    }
    let result = await db.icons.get({ key: key });
    if (!result) {
      result = await db.icons.get({ key: key });
    }
    iconsCache.set(key, result);
    return result;
  } catch (error) {
    console.error('Error fetching icon:', error);
    return null;
  }
};

export const fetchAllIconsFromKodefastAPI = async () => {
  try {
    const response = await axios.get(appConfig.kvKodefastUrl + '/company-icons/master/data', {
      headers: {
        Authorization: appConfig.authKey,
        'Content-Type': 'application/json',
      },
    });
    const allIcons = Array.isArray(response.data) ? response.data : response.data.data;
    return allIcons;
  } catch (err) {
    console.error('Failed to fetch master icon names:', err.message);
    return [];
  }
};

export const fetchAllMarketPlaceIcons = async () => {
  try {
    const response = await axios.get(
      appConfig.kvKodefastUrl + '/company-icons/master/data/marketplace',
      {
        headers: {
          Authorization: appConfig.authKey,
          'Content-Type': 'application/json',
        },
      }
    );
    const allIcons = Array.isArray(response.data) ? response.data : response.data.data;
    return allIcons;
  } catch (err) {
    console.error('Failed to fetch market place icons:', err.message);
    return [];
  }
};

export const getIconKeysFromMasterIcons = async (iconsNames) => {
  let apiIcons = store.getters['icons/getApiIcons'];
  if (!apiIcons || apiIcons.length === 0) {
    await store.dispatch('icons/fetchApiIcons');
    apiIcons = store.getters['icons/getApiIcons'];
  }
  const iconMap = {};
  apiIcons.forEach((icon) => {
    const key = icon.key;
    const mainName = icon.name?.replace(/\.svg$/i, '');
    if (mainName) {
      iconMap[mainName] = key;
      iconMap[mainName.toLowerCase()] = key;
    }
    if (Array.isArray(icon.alt_names)) {
      icon.alt_names.forEach((alt) => {
        const cleanedAlt = alt.replace(/\.svg$/i, '');
        iconMap[cleanedAlt] = key;
        iconMap[cleanedAlt.toLowerCase()] = key;
      });
    }
  });
  return iconsNames.map((name) => {
    const cleanedName = name.replace(/\.svg$/i, '');
    if (cleanedName === 'block-portfolio') {
      return 'dashboard';
    }
    return iconMap[cleanedName] || iconMap[cleanedName.toLowerCase()] || cleanedName;
  });
};

export const fetchSvgContentFromS3 = async (iconNames = []) => {
  if (!iconNames || iconNames.length === 0) {
    iconNames = ['dashboard'];
  }
  const baseUrl = appConfig.s3BaseUrl;
  const cleanSvg = (rawSvg) => {
    return rawSvg?.replace(/\\n/g, '').replace(/\\"/g, '"').replace(/\\\\/g, '');
  };
  const iconPromises = iconNames.map(async (name) => {
    const svgUrl = `${baseUrl}/${name}.svg`;
    try {
      const svgResponse = await axios.get(svgUrl, { responseType: 'text' });
      return {
        name,
        content: cleanSvg(svgResponse.data),
      };
    } catch (err) {
      console.warn(`Failed to fetch SVG for ${name}:`, err.message);
      return null;
    }
  });
  return (await Promise.all(iconPromises)).filter(Boolean);
};

export const createIcons = async (key, valueArray) => {
  try {
    const uniqueValues = [...new Set(valueArray)];
    const payload = {
      key,
      value: uniqueValues,
    };
    const response = await axios.post(appConfig.kvKodefastUrl + '/company-icons', payload, {
      headers: {
        Authorization: appConfig.authKey,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error in createIcons:', error);
    throw error;
  }
};

export const getIcons = async (key) => {
  try {
    const url = appConfig.kvKodefastUrl + `/company-icons/${key}`;
    const response = await axios.get(url, {
      headers: {
        Authorization: appConfig.authKey,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (err) {
    console.error(`Failed to fetch icons for key "${key}":`, err.message);
    throw err;
  }
};

export const getAllIconsByCompanyId = async (companyId) => {
  try {
    const url = appConfig.kvKodefastUrl + `/company-icons?companyId=${companyId}`;
    const response = await axios.get(url, {
      headers: {
        Authorization: appConfig.authKey,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (err) {
    console.error(`Failed to fetch icons for companyId "${companyId}":`, err.message);
    throw err;
  }
};
